/* eslint-disable sonarjs/no-duplicate-string */
import { helpers } from './base'

export const CancellationPolicyModal = helpers.defineMultiStyleConfig({
  baseStyle: {
    cancellationFeesAndPoliciesContainer: {
      h1: {
        fontSize: 'var(--alto-sem-text-heading-sm-font-size)',
        my: { base: 'sm', lg: 'lg' },
        fontWeight: 'medium',
        color: 'fg.accent.secondary',
      },
      strong: {
        fontWeight: 'medium',
      },
      p: {
        fontSize: {
          base: 'sm',
          lg: 'md',
        },
      },
    },
    policyLink: {
      color: 'fg.accent.primary',
      fontSize: {
        base: 'var(--alto-sem-text-body-sm-font-size)',
        lg: 'var(--alto-sem-text-body-md-font-size)',
      },

      _hover: {
        textDecoration: 'none',
      },
    },
  },
})
